module.exports = __webpack_public_path__ + "img/wedss2.c4b3b6a5.jpg";